class Quality {

    constructor(mongoDBConnector) {
        this.mongoDBConnector = mongoDBConnector;
    }

    /**
     *
     * @param {*} participant address
     * @param {*} options : (type) Object
     *                      Keys 'type' and 'state'
     *                          type : sales - the function will return all the receipt ids sent by the participant.
     *                          type : purchases - the function will return all the receipt ids received by the participant.
     *                          type : undefined -  gives all the receipts based on the participant
     *                          state : "0","1","2","3","4"
     *                          state : undefined - gives all the receipts with different states.
     *
     */
    getAllLatestReceipts(participant, options, fromDate, toDate) {
        return this.mongoDBConnector.invoke('quality', "getAllLatestReceipts", participant, options, fromDate, toDate);
    }

    /**
     *
     * @param {*} participant address
     * @param {*} options : (type) Object
     *                      Keys 'type' and 'state'
     *                          type : sales - the function will return all the receipt ids sent by the participant.
     *                          type : purchases - the function will return all the receipt ids received by the participant.
     *                          type : undefined -  gives all the receipts based on the participant
     *                          state : "0","1","2","3","4"
     *                          state : undefined - gives all the receipts with different states.
     *
     */
    getAllReceipts(participant, options, fromDate, toDate) {
        return this.mongoDBConnector.invoke('quality', "getAllReceipts", participant, options, fromDate, toDate);


    }

    getAllReceiptsByCurrency(participant, options, fromDate, toDate, currency) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByCurrency", participant, options, fromDate, toDate, currency);


    }


    getInvoicesByDisputeKey(owner, disputeKey, type) {
        return this.mongoDBConnector.invoke('quality', "getInvoicesByDisputeKey", owner, disputeKey, type);


    }

    getAllLatestReceiptsByStatus(participant, options, fromDate, toDate) {
        return this.mongoDBConnector.invoke('quality', "getAllLatestReceiptsByStatus", participant, options, fromDate, toDate);


    }

    //isClosed:0 - false
    //isClosed:1 - true
    getAllReceiptsByStep(from, to, step, type, isLogistics) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByStep", from, to, step, type, isLogistics);
    }

    getAllReceiptsByParent(parentDocId) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByParent", parentDocId);
    }

    getAllReceiptsByParentV1(parentDocId) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByParentV1", parentDocId);
    }

    getAllReceiptsByParentAndSubType(parentDocId, subType) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByParentAndSubType", parentDocId, subType);
    }

    getAllCurrencies() {
        return this.mongoDBConnector.invoke('quality', "getAllCurrencies");
    }

    getParentDocId(childDocId) {
        return this.mongoDBConnector.invoke('quality', "getParentDocId", childDocId);
    }

    getInvoiceFromPoAndInvoiceInternalId(poId, invoiceInternalId) {
        return this.mongoDBConnector.invoke('quality', "getInvoiceFromPoAndInvoiceInternalId", poId, invoiceInternalId);
    }

    getParentDocInternalId(childDocId) {
        return this.mongoDBConnector.invoke('quality', "getParentDocInternalId", childDocId);
    }
    getSellerAndBuyer(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getSellerAndBuyer", receiptId);
    }

    /**
     * 
     * @param {
        return this.mongoDBConnector.invoke('quality', "receipts", participant, options, fromDate, toDate);
     * *} receiptId 
     * @param {
        return this.mongoDBConnector.invoke('quality', "receipts", participant, options, fromDate, toDate);
     * *} predicates Array -> possible values include :
     *                          status
     *                          providerName
     *                          customerName
     *                          amount
     *                          currency
     *                          date
     *                          isTemplateCompleted
     *                          docInternalId
     *                          docStep
     *                          additionalProperty
     *                          parentDocInternalId
     *                          step
     *                          disputeInfo
     *                          @subType
     *                          customerParamId
     *                          providerParamId
     *                          paymentTerms
     *                          transactionType
     */
    getSummary(receiptId, predicates) {
        return this.mongoDBConnector.invoke('quality', "getSummary", receiptId, predicates);
    }

    getSummaryInBulk(receiptIds, predicates) {
        return this.mongoDBConnector.invoke('quality', "getSummaryInBulk", receiptIds, predicates);
    }

    getAllItemsSummaryForReceipt(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getAllItemsSummaryForReceipt", receiptId);


    }

    getValidationData(docId, step) {
        return this.mongoDBConnector.invoke('quality', "getValidationData", docId, step);


    }

    getItemQuantitySummary(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getItemQuantitySummary", receiptId);


    }

    getReceiptInternalId(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getReceiptInternalId", receiptId);
    }

    getReceiptInfoByNode(receiptId, node) {
        return this.mongoDBConnector.invoke('quality', "getReceiptInfoByNode", receiptId, node);
    }

    isDocumentRejected(receiptId) {
        return this.mongoDBConnector.invoke('quality', "isDocumentRejected", receiptId);
    }

    getRootReceiptId(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getRootReceiptId", receiptId);
    }

    // receiptId -> root id 
    getAllReceiptIdsInTree(receiptId, receiptArray) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptIdsInTree", receiptId, receiptArray);
    }

    getAllReceiptIdsInPath(source, destination, receiptArray) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptIdsInPath", source, destination, receiptArray);
    }

    getRootReceiptIdFromGrn(grnId) {
        return this.mongoDBConnector.invoke('quality', "getRootReceiptIdFromGrn", grnId);


    }

    getReceiptV2(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getReceiptV2", receiptId);


    }

    getReceipt(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getReceipt", receiptId);


    }

    getReceiptsByItem(itemId, step, filter, filterType) {
        return this.mongoDBConnector.invoke('quality', "getReceiptsByItem", itemId, step, filter, filterType);
    }

    getReceiptMetaData(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getReceiptMetaData", receiptId);


    }

    doesExist(receiptId) {
        return this.mongoDBConnector.invoke('quality', "doesExist", receiptId);


    }

    doesChildExist(parentDocId, internalChildId, childStep) {
        return this.mongoDBConnector.invoke('quality', "doesChildExist", parentDocId, internalChildId, childStep);


    }

    getNoAccessStatus(receiptId) {
        return this.mongoDBConnector.invoke('quality', "getNoAccessStatus", receiptId);


    }

    getTransactions(receiptId) {
        return this.mongoDBConnector.invoke('quality', "receipgetTransactionsts", receiptId);
    }

    getAllReceiptsByTypeForExport(type, step) {
        return this.mongoDBConnector.invoke('quality', "getAllReceiptsByTypeForExport", type, step);
    }

    addReceipt(receiptId, jsonLd, status, parentDocId, step, grnManager) {
        return this.mongoDBConnector.invoke('quality', "addReceipt", receiptId, jsonLd, status, parentDocId, step, grnManager);
    }

    addReceipts(receiptArray) {
        return this.mongoDBConnector.invoke('quality', "addReceipts", receiptArray);
    }

    extractItemMapping(jsonLd, promiseArray) {
        return this.mongoDBConnector.invoke('quality', "extractItemMapping", jsonLd, promiseArray);

    }


    adjustInventory(jsonLd, action) {
        return this.mongoDBConnector.invoke('quality', "adjustInventory", jsonLd, action);


    }

    editDisputedInfoAndState(docId) {
        return this.mongoDBConnector.invoke('quality', "editDisputedInfoAndState", docId);


    }

    addCurrency(currency, docId) {
        return this.mongoDBConnector.invoke('quality', "addCurrency", currency, docId);


    }

    updateReceipt(receiptId, jsonLd, status, parentDocId, step, grnManager) {
        return this.mongoDBConnector.invoke('quality', "updateReceipt", receiptId, jsonLd, status, parentDocId, step, grnManager);


    }
    writeNote(receiptId, note, status) {
        return this.mongoDBConnector.invoke('quality', "writeNote", receiptId, note, status);
    }

    updateStatus(receiptId, newStatus, step) {
        return this.mongoDBConnector.invoke('quality', "updateStatus", receiptId, newStatus, step);


    }

    appendStatus(receiptId, status) {
        return this.mongoDBConnector.invoke('quality', "appendStatus", receiptId, status);


    }

    writeStatus(receiptId, status, step) {
        return this.mongoDBConnector.invoke('quality', "writeStatus", receiptId, status, step);

    }

    deleteNoAccess(receiptId) {
        return this.mongoDBConnector.invoke('quality', "deleteNoAccess", receiptId);

    }



    insertGrnId(docId, grnId) {
        return this.mongoDBConnector.invoke('quality', "insertGrnId", docId, grnId);


    }

    doesGrnExistByDocId(docId, grnId) {
        return this.mongoDBConnector.invoke('quality', "doesGrnExistByDocId", docId, grnId);


    }

    detachGrn(docIds, grnId) {
        return this.mongoDBConnector.invoke('quality', "detachGrn", docIds, grnId);


    }

    getChildByInvoiceNumber(docId, invoiceNumber) {
        return this.mongoDBConnector.invoke('quality', "getChildByInvoiceNumber", docId, invoiceNumber);


    }

    updateDisputeInfo(docId, disputeInfo) {
        return this.mongoDBConnector.invoke('quality', "updateDisputeInfo", docId, disputeInfo);


    }

    attachReturn(parentDocId, returnsId) {
        return this.mongoDBConnector.invoke('quality', "attachReturn", parentDocId, returnsId);


    }

    updateInvoiceReferencesOrderForGRN(docId, referencesOrder) {
        return this.mongoDBConnector.invoke('quality', "updateInvoiceReferencesOrderForGRN", docId, referencesOrder);
    }
    updateMasterPOForPartPO(partPOId, docId, partPOJsonLd) {
        return this.mongoDBConnector.invoke('quality', "updateMasterPOForPartPO", partPOId, docId, partPOJsonLd);
    }

    //Get all invoices attached to a credit note
    getAttachedInvoices(creditNoteId) {
        return this.mongoDBConnector.invoke('quality', 'getAttachedInvoices', creditNoteId);
    }
}

export default Quality;
